import { format } from "date-fns"
import { ru } from "date-fns/locale/ru"
import type { AudienceCard, AudienceEvent } from "../api/audience-api"
import { EventView } from "./event-view"

export function History({ card, botId }: { card: AudienceCard; botId: string }) {
	if (card.events.length === 0) {
		return (
			<p className="px-4 py-6 text-center text-sm text-muted-foreground">
				История появится с новыми сообщениями боту
			</p>
		)
	}
	const days: { day: string; events: AudienceEvent[] }[] = []
	for (const event of card.events) {
		const day = format(new Date(event.createdAt), "d MMMM yyyy", { locale: ru })
		const last = days.at(-1)
		if (last?.day === day) last.events.push(event)
		else days.push({ day, events: [event] })
	}
	return (
		<div className="space-y-4 p-3">
			{card.hasOlderEvents ? (
				<p className="text-center text-xs text-muted-foreground">Показаны последние события</p>
			) : null}
			{days.map(({ day, events }) => (
				<div key={day} className="space-y-1.5">
					<p className="py-1 text-center">
						<span className="rounded-full bg-muted/60 px-2.5 py-0.5 text-[11px] text-muted-foreground">
							{day}
						</span>
					</p>
					{events.map((event) => (
						<EventView key={event.id} event={event} botId={botId} sessionId={card.member.id} />
					))}
				</div>
			))}
		</div>
	)
}
